import { render, staticRenderFns } from "./composite.vue?vue&type=template&id=6ecb3615&scoped=true&"
import script from "./composite.vue?vue&type=script&lang=js&"
export * from "./composite.vue?vue&type=script&lang=js&"
import style0 from "./composite.vue?vue&type=style&index=0&id=6ecb3615&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecb3615",
  null
  
)

/* custom blocks */
import block0 from "./composite.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports